export interface Point { x: number; y: number }
export function solveAim(pivot: Point, target: Point, barrel: number, speed: number) {
  const dx = target.x - pivot.x;
  const dy = target.y - pivot.y;
  const length = Math.hypot(dx, dy) || 1;
  const direction = { x: dx / length, y: dy / length };
  return { direction, angle: Math.atan2(direction.y, direction.x), muzzle: { x: pivot.x + direction.x * barrel, y: pivot.y + direction.y * barrel }, velocity: { x: direction.x * speed, y: direction.y * speed } };
}